import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserInfoEffects } from './store/user-info.effects';
import { reducer, userFeatureKey } from './store/user.reducer';

@NgModule({
  imports: [
    CommonModule
    , StoreModule.forFeature(userFeatureKey, reducer)
    , EffectsModule.forFeature([UserInfoEffects]),
  ],
  declarations: []
})
export class UserInfoModule { }
